import { Injectable } from '@angular/core';
import { catchError, map, Observable, tap, throwError } from 'rxjs';
import { Product } from '../interfaces/pProduct';
import { HttpClient } from '@angular/common/http';
import { WebAddresses } from '../app.config';
import { ApiResponse } from '../interfaces/api-response';
import { openSnackBar } from '../helpers/genericFunctions';
import { MatSnackBar } from '@angular/material/snack-bar';
import { globalUser } from '../helpers/globalFields';
/**
 * Service that gets master product data from api. Master product data contains all supported devices and products that the helpdesk offers support for.
   * TODO: SHOULD BE MOVED TO masterDataService
 */
@Injectable({
  providedIn: 'root'
})
export class ProductService {
  /**
   * constructor
   * 
   * @param http httpClient to interact with api
   * @param snackBar Overlay to display errors and success messages to end user
   */
  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar
  ) { }

   /**
   * allows easy switching between production and development webserver addresses for api
   */
   private baseUrl = WebAddresses.tCCTicketServer;
  
  
  /**
   * gets all pProducts from API.
   * 
   * @returns list of all available products
   */
  getProducts(): Observable<Product[]> {
    return this.http.get<ApiResponse>(`${this.baseUrl}/api/pproduct/findall`, { 
      headers: globalUser.getHeaders() 
    }).pipe(
          tap(response => {
            if (response.status != "success") {
              openSnackBar(response.message, 10000, this.snackBar);
            }
          }),
          map(response => response.data ?? []),
          catchError(error => {
            console.error("Error fetching pProducts:", error);
            return throwError(() => new Error("Failed to fetch pProducts"));
          })
        );
  }
}
